import React from 'react'
import styled from 'styled-components'
import { TouchBallLoading } from 'react-loadingg';

function Loader() {
  return (
    <LoaderContainer>
        <TouchBallLoading color={"#F7707D"} size={"large"} speed={1}/>
    </LoaderContainer>
  )
}

export default Loader

const LoaderContainer = styled.div`
    width: 100%;
    height: 100vh;
    height: 100dvh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.9);
`
